import {
  GeckoComponentModel,
  GeckoComponentModelType,
  GeckoCone,
  GeckoConeCourse,
  GeckoLegacyBoilerWall,
  GeckoLegacyBoilerWalls,
  GeckoLegacyCone,
  GeckoShellCourse,
  GeckoVerticalTankShell,
} from 'types'

export function getSectionsFromComponentModel(
  componentModel: GeckoVerticalTankShell | GeckoLegacyCone | GeckoCone
): GeckoShellCourse[] | GeckoConeCourse[]
export function getSectionsFromComponentModel(
  componentModel: GeckoLegacyBoilerWalls
): GeckoLegacyBoilerWall[]
export function getSectionsFromComponentModel(
  componentModel: GeckoComponentModel
): GeckoShellCourse[] | GeckoConeCourse[] | GeckoLegacyBoilerWall[] | undefined
export function getSectionsFromComponentModel(
  componentModel: GeckoComponentModel
):
  | GeckoShellCourse[]
  | GeckoConeCourse[]
  | GeckoLegacyBoilerWall[]
  | undefined {
  switch (componentModel.type) {
    case GeckoComponentModelType.VerticalTankShell:
    case GeckoComponentModelType.LegacyCone:
    case GeckoComponentModelType.Cone:
      return componentModel.coursesArray
    case GeckoComponentModelType.LegacyBoilerWalls:
      return componentModel.wallsArray
    default:
      return undefined
  }
}
